import { SelectItem } from 'primeng/api';
import { normalizeString } from '@lx/shared/utils';

/**
 * Finds a school location within grouped school locations by school code.
 * Iterates through countries and schools to find a matching school.
 *
 * @param groupedSchoolLocations - Array of grouped school locations organized by country
 * @param schoolCode - The school code to search for
 * @returns SchoolLocation object if found, undefined otherwise
 */
export function findSchoolLocationByCode(
  groupedSchoolLocations: Array<{ value?: string; label?: string; weight?: number; items?: Array<{ value?: string; label?: string; weight?: number }> }>,
  schoolCode: string,
): { countryCode: string; countryName: string; schoolCode: string; schoolName: string } | undefined {
  if (!schoolCode || !groupedSchoolLocations?.length) {
    return undefined;
  }

  for (const location of groupedSchoolLocations) {
    const schoolLocationItem = location.items?.find(({ value }: SelectItem) => normalizeString(value) === normalizeString(schoolCode));
    if (schoolLocationItem) {
      const { value: foundSchoolCode, label: schoolName } = schoolLocationItem;
      const { value: countryCode, label: countryName } = location;

      return {
        countryCode: countryCode || '',
        countryName: countryName || '',
        schoolCode: foundSchoolCode || '',
        schoolName: schoolName || '',
      };
    }
  }

  return undefined;
}
